<div class="risk-assessment-matrix-container" [class.form-mode]="isFormMode" [class.disabled]="disabled" [class.success]="hasValidResult()">
  <div class="matrix-header" *ngIf="item.label">
    <h5 class="matrix-title">{{ item.label }}</h5>
    <span class="required-indicator" *ngIf="item.required">*</span>
  </div>

  <!-- 表單填寫模式：簡化的維度選擇器 -->
  <div class="simplified-dimensions" *ngIf="isFormMode">
    <div class="dimension-selector" *ngFor="let dimension of item.config.dimensions; let i = index">
      <label class="dimension-label">
        {{ dimension.name }}
        <span class="dimension-description" *ngIf="dimension.description">
          - {{ dimension.description }}
        </span>
      </label>

      <select
        class="dimension-select"
        [ngModel]="selectedValues[i]"
        (ngModelChange)="onDimensionValueChange(i, $event)"
        [disabled]="disabled">
        <option value="0">{{ ('form.risk_matrix.please_select' | translate) || '請選擇' }} {{ dimension.name }}</option>
        <option
          *ngFor="let level of dimension.levels"
          [value]="level.value"
          [title]="level.description">
          {{ level.name }} ({{ level.value }}){{ level.description ? ' - ' + level.description : '' }}
        </option>
      </select>
    </div>
  </div>

  <!-- 表單填寫模式：風險結果顯示 -->
  <div class="risk-result" *ngIf="isFormMode" [class.has-result]="hasValidResult()">
    <div class="result-header">
      <h6 class="result-title">{{ ('form.risk_matrix.risk_result' | translate) || '風險評估結果' }}</h6>
    </div>

    <div class="result-content" *ngIf="hasValidResult(); else noResultTemplate">
      <div class="risk-score">
        <div class="score-label">{{ ('form.risk_matrix.risk_score' | translate) || '風險分數' }}</div>
        <div class="score-value">{{ calculatedResult }}</div>
      </div>

      <div class="risk-level" *ngIf="currentRiskLevel">
        <div class="level-label">{{ ('form.risk_matrix.risk_level' | translate) || '風險等級' }}</div>
        <div
          class="level-badge"
          [style.background-color]="currentRiskLevel.bgColor"
          [style.color]="currentRiskLevel.textColor"
          [style.border-color]="currentRiskLevel.bgColor">
          {{ currentRiskLevel.name }}
        </div>
      </div>
    </div>

    <ng-template #noResultTemplate>
      <div class="no-result">
        <div>{{ ('form.risk_matrix.no_result' | translate) || '請選擇所有維度的等級以計算風險分數' }}</div>
      </div>
    </ng-template>
  </div>

  <!-- 原有模式：維度選擇器（當維度數量大於2或不等於2時顯示） -->
  <div class="dimensions-selector" *ngIf="!isFormMode && item.config.dimensions.length !== 2">
    <div class="dimension-item" *ngFor="let dimension of item.config.dimensions; let i = index">
      <div class="dimension-header">
        <label class="dimension-label">
          {{ dimension.name }}
          <span class="dimension-description" *ngIf="dimension.description">
            ({{ dimension.description }})
          </span>
        </label>
      </div>

      <select
        class="form-control dimension-select"
        [ngModel]="selectedValues[i]"
        (ngModelChange)="onDimensionValueChange(i, $event)"
        [disabled]="disabled">
        <option value="0">{{ ('form.risk_matrix.please_select' | translate) || '請選擇' }} {{ dimension.name }}</option>
        <option
          *ngFor="let level of dimension.levels"
          [value]="level.value"
          [title]="level.description">
          {{ level.name }} ({{ level.value }})
        </option>
      </select>
    </div>
  </div>

  <!-- 原有模式：2x2 矩陣顯示 -->
  <div class="matrix-display" *ngIf="!isFormMode && item.config.dimensions.length === 2">
    <!-- 維度標籤 -->
    <div class="matrix-labels">
      <div class="y-axis-label">
        <span class="dimension-name">{{ item.config.dimensions[0].name }}</span>
        <span class="dimension-desc" *ngIf="item.config.dimensions[0].description">
          {{ item.config.dimensions[0].description }}
        </span>
      </div>
      <div class="x-axis-label">
        <span class="dimension-name">{{ item.config.dimensions[1].name }}</span>
        <span class="dimension-desc" *ngIf="item.config.dimensions[1].description">
          {{ item.config.dimensions[1].description }}
        </span>
      </div>
    </div>

    <!-- 矩陣表格 -->
    <div class="matrix-table-container">
      <!-- X軸標籤 -->
      <div class="x-axis-labels">
        <div class="axis-label-spacer"></div>
        <div
          class="x-label"
          *ngFor="let level of item.config.dimensions[1].levels; let j = index">
          <span class="level-name">{{ level.name }}</span>
          <span class="level-value">({{ level.value }})</span>
        </div>
      </div>

      <!-- 矩陣內容 -->
      <div class="matrix-content">
        <!-- Y軸標籤和矩陣行 -->
        <div
          class="matrix-row"
          *ngFor="let row of getMatrixCells(); let i = index">

          <!-- Y軸標籤 -->
          <div class="y-label">
            <span class="level-name">{{ getLevelName(item.config.dimensions[0], item.config.dimensions[0].levelCount - i) }}</span>
            <span class="level-value">({{ item.config.dimensions[0].levelCount - i }})</span>
          </div>

          <!-- 矩陣格子 -->
          <div
            class="matrix-cell"
            *ngFor="let cell of row; let j = index"
            [class.selected]="isCellSelected(i, j)"
            [style.background-color]="cell.riskLevel?.bgColor || '#f8f9fa'"
            [style.color]="cell.riskLevel?.textColor || '#000'"
            [title]="cell.riskLevel?.name + ' (' + ('form.risk_matrix.value_label' | translate) + ': ' + cell.value + ')'"
            (click)="onMatrixCellClick(i, j)">

            <div class="cell-content">
              <div class="cell-value">{{ cell.value }}</div>
              <div class="cell-risk-level" *ngIf="cell.riskLevel">
                {{ cell.riskLevel.name }}
              </div>
            </div>

            <!-- 選中指示器 -->
            <div class="selection-indicator" *ngIf="isCellSelected(i, j)">
              <i class="fas fa-check"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 原有模式：計算結果顯示 -->
  <div class="calculation-result" *ngIf="!isFormMode && calculatedResult > 0">
    <div class="result-header">
      <i class="fas fa-calculator"></i>
      <span>{{ ('form.risk_matrix.risk_result' | translate) || '風險評估結果' }}</span>
    </div>

    <div class="result-content">
      <div class="calculation-detail">
        <span class="calculation-formula">
          <ng-container *ngIf="item.config.calculationMode === 'add'">
            {{ selectedValues.join(' + ') }} = {{ calculatedResult }}
          </ng-container>
          <ng-container *ngIf="item.config.calculationMode === 'multiply'">
            {{ selectedValues.join(' × ') }} = {{ calculatedResult }}
          </ng-container>
        </span>
      </div>

      <div class="risk-level-result" *ngIf="currentRiskLevel">
        <div
          class="risk-level-badge"
          [style.background-color]="currentRiskLevel.bgColor"
          [style.color]="currentRiskLevel.textColor">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{ currentRiskLevel.name }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- 風險等級說明 -->
  <div class="risk-levels-legend" *ngIf="!isFormMode && !viewMode">
    <div class="legend-header">
      <i class="fas fa-info-circle"></i>
      <span>{{ ('form.risk_matrix.legend' | translate) || '風險等級說明' }}</span>
    </div>
    <div class="legend-items">
      <div
        class="legend-item"
        *ngFor="let level of item.config.riskLevels"
        [style.background-color]="level.bgColor"
        [style.color]="level.textColor">
        <span class="legend-name">{{ level.name }}</span>
        <span class="legend-range">({{ level.range[0] }}-{{ level.range[1] }})</span>
      </div>
    </div>
  </div>
</div>
